import baseBackground from 'assets/background/base.png';
import dominoBackground from 'assets/background/domino.jpg';

import backgammonLogo from 'assets/logo/backgammon.png';
import dominoLogo from 'assets/logo/domino.png';
import spadesLogo from 'assets/logo/spades.png';
import rummyRushLogo from 'assets/logo//rummy_rush.png';
import rummyStarsLogo from 'assets/logo/rummy_stars.png';
import tilezLogo from 'assets/logo/tilez.png';
import opaLogo from 'assets/logo/opa.png';

export default {
  backgammon: {
    background: baseBackground,
    logo: backgammonLogo,
    width: 150,
    freshchat: 'd2873638-61f1-4548-97d7-2996489d31f9',
    whatsapp: '37259619711',
    iMessage: 'c2a300fb-036a-4493-a317-88ef8473e9e0',
  },
  domino: {
    background: dominoBackground,
    logo: dominoLogo,
    width: 180,
    freshchat: null,
    whatsapp: null,
    iMessage: null,
  },
  spades: {
    background: baseBackground,
    logo: spadesLogo,
    width: 120,
    freshchat: null,
    whatsapp: null,
    iMessage: null,
  },
  rummyRush: {
    background: baseBackground,
    logo: rummyRushLogo,
    width: 180,
    freshchat: null,
    whatsapp: null,
    iMessage: null,
  },
  rummyStars: {
    background: baseBackground,
    logo: rummyStarsLogo,
    width: 150,
    freshchat: null,
    whatsapp: null,
    iMessage: null,
  },
  tilez: {
    background: baseBackground,
    logo: tilezLogo,
    width: 200,
    freshchat: null,
    whatsapp: null,
    iMessage: null,
  },
  opa: {
    background: baseBackground,
    logo: opaLogo,
    width: 180,
    freshchat: null,
    whatsapp: null,
    iMessage: null,
  },
};
